import { NavLink } from "react-router-dom";
import { BRAND_FULL_NAME, BRAND_NAME, BRAND_SUBTITLE } from "../../config/brand";
import "./SiteLogo.sass";

function SiteLogo({ to, variant = "header" }) {
    return (
        <NavLink to={to} className={`site-logo site-logo--${variant}`} aria-label={BRAND_FULL_NAME}>
            <span className="site-logo__name">{BRAND_NAME}</span>
            <span className="site-logo__subtitle">{BRAND_SUBTITLE}</span>
        </NavLink>
    );
}

export default SiteLogo;
